export default defineNuxtPlugin(async () => {
  if (!import.meta.client) return

  const sync = useOfflineSync()
  await sync.loadPendingCount()

  if (navigator.onLine) {
    await sync.sync()
  }

  try {
    const { App: CapApp } = await import('@capacitor/app')
    CapApp.addListener('appStateChange', async ({ isActive }) => {
      if (isActive && navigator.onLine) {
        await sync.sync()
      }
    })
  } catch {}
})
